import { qs, listen, add } from '@fluorescent/dom';
import selectors from '@/lib/selectors';

const {
  strings: { accessibility: strings },
} = theme;

const focusFormStatus = node => {
  const formStatus = qs(selectors.a11y.formStatus, node);

  if (!formStatus) return;

  const focusElement = qs('[data-form-status]', formStatus);

  focusElement.focus();
};

const prefersReducedMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

function backgroundVideoHandler(container) {
  const pause = qs('.video-pause', container);
  const video = container.getElementsByTagName('VIDEO')[0];

  if (!pause || !video) return;

  const pauseListener = listen(pause, 'click', e => {
    e.preventDefault();

    if (video.paused) {
      video.play();
      pause.innerText = strings.pause_video;
    } else {
      video.pause();
      pause.innerText = strings.play_video;
    }
  });

  return () => pauseListener();
}

export { focusFormStatus, prefersReducedMotion, backgroundVideoHandler };
